export default "__VITE_ASSET__DidjGHPi__"